var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { PastInteractionColumn } from "./Constant";
import downloadimg from "@frameworks/shared-library/assets/images/SalesJourney/download-img.svg";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "../../../../../../shared-library/components/Loader";
import { getDateInFormat, getFinancialYear } from "@domains/utils/reportDates";
import moment from "moment";
import CalendarPopupDesk from "../../../../../../shared-library/components/Calendar/CalendarPopupDesk";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import EdModal from "@frameworks/web/components/generic/edModal";
import SuccessPopup from "../../../../../../shared-library/components/SuccessPopup";
import FailurePopup from "../../../../../../shared-library/components/FailurePopup";
var PastInteraction = function () {
    var _a = __read(React.useState([]), 2), pastIntractionDetailsData = _a[0], setPastIntractionDetailsData = _a[1];
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(React.useState(getFinancialYear(new Date())), 2), finYear = _c[0], setFinYear = _c[1];
    var _d = __read(React.useState(false), 2), openCalendar = _d[0], setOpenCalendar = _d[1];
    var _e = __read(React.useState(finYear + 1), 2), nextFinYear = _e[0], setNextFinYear = _e[1];
    var _f = __read(React.useState(new Date(finYear + 1, 2, 31)), 2), endDate = _f[0], setEndDate = _f[1];
    var _g = __read(React.useState(new Date(finYear, 3, 1)), 2), startDate = _g[0], setStartDate = _g[1];
    var _h = __read(useState(), 2), downloadLoader = _h[0], setDownloadLoader = _h[1];
    var _j = __read(useState(false), 2), downloadSuccess = _j[0], setDownloadSuccess = _j[1];
    var _k = __read(useState(false), 2), downloadFail = _k[0], setDownloadFail = _k[1];
    var getPastIntractionDetailsData = function (data) {
        setLoader(true);
        di.clients
            .getPastIntractionDetailsData(data)
            .then(function (data) {
            if (data) {
                setPastIntractionDetailsData(data);
            }
            setLoader(false);
        })
            .catch(function (error) {
            console.log("fetching Eligibility data failed", error);
            setLoader(false);
        });
    };
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    React.useEffect(function () {
        if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)
            getPastIntractionDetailsData({
                acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            });
    }, [selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode]);
    React.useEffect(function () {
        getPastIntractionDetailsData({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            fromDate: moment(startDate).format("YYYY-MM-DD"),
            toDate: moment(endDate).format("YYYY-MM-DD"),
        });
    }, [startDate, endDate]);
    var downloadPastInteraction = function () {
        if (selectedAcount) {
            var payload_1 = {
                fromDate: moment(startDate).format("YYYY-MM-DD"),
                toDate: moment(endDate).format("YYYY-MM-DD"),
                acCode: selectedAcount.accountCode,
            };
            setDownloadLoader(true);
            di.clients
                .getPastInteractionDownload(payload_1)
                .then(function (val) {
                setDownloadLoader(false);
                if (val.success) {
                    setDownloadSuccess(true);
                    base64toExcel(val.data, "PAST_INTERACTION_" +
                        selectedAcount.accountCode.toString() +
                        getDateInFormat(payload_1.fromDate, "DD_MM_YYYY") +
                        ".csv");
                }
            })
                .catch(function (err) {
                setDownloadLoader(false);
                setDownloadFail(true);
            });
        }
    };
    return (React.createElement(React.Fragment, null, loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement("div", { className: "pastinteraction-main-block mx-0 px-0" },
        React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 px-0 past-interactions-head" }, "Past Interactions"),
        React.createElement("div", { className: "px-0 mx-0 selectdate-row d-flex justify-content-between align-items-center" },
            React.createElement("div", { className: "sales-calendar" },
                React.createElement("div", { className: "d-flex calendar-block m-0" },
                    React.createElement("label", { className: "txt_blackOne1 DMSansMedium_20_500" },
                        "FY ",
                        finYear,
                        "-",
                        nextFinYear.toString().substring(2),
                        React.createElement("span", { className: "DMSansNormal_20_400" },
                            "\u00A0(",
                            moment(startDate).format("D-MMM-YY"),
                            "\u00A0 to ",
                            moment(endDate).format("D-MMM-YY"),
                            ")")),
                    React.createElement("i", { className: "edel-icon-calendar2 txt-midnight-blue" }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Change", onClick: function () { return setOpenCalendar(!openCalendar); } })),
                React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear })),
            React.createElement("div", { className: "download-btn", onClick: function () { return downloadPastInteraction(); } },
                React.createElement("button", { className: "btn  downloads justify-content-between disabled" },
                    React.createElement("img", { className: "", src: downloadimg }),
                    React.createElement("span", { className: "DMSanM_14_500 txt-midnight-blue download-txt" }, "Download")))),
        React.createElement(GenericTable, { columns: PastInteractionColumn, data: pastIntractionDetailsData, parentClassName: "salestableParentClass table-responsive commonscroll-new", tableClassName: "salestableclass" }),
        React.createElement(EdModal, { show: downloadLoader, setShow: setDownloadLoader, showFooter: false, size: "modal-md modal-dialog-centered", modalTitle: "", children: React.createElement("div", { className: "position-relative m-5 p-5" },
                React.createElement(Loader, null)) }),
        React.createElement(EdModal, { show: downloadSuccess, setShow: setDownloadSuccess, showFooter: false, modalTitle: "", children: React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("i", { className: "edel-icon-msg" }),
                    "Download"), message: "Successfully downloaded", operation: "download" }) }),
        React.createElement(EdModal, { show: downloadFail, setShow: setDownloadFail, showFooter: false, modalTitle: "", children: React.createElement(FailurePopup, { setDownloadFail: setDownloadFail, Title: React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("i", { className: "edel-icon-msg" }),
                    "Download"), operation: "download" }) })))));
};
export default PastInteraction;
